exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectBorder[data-v-71fc1726]  .el-input__inner{border:none}.selectBorder input[data-v-71fc1726]::-webkit-input-placeholder{color:red}.selectBorder input[data-v-71fc1726]::-moz-placeholder{color:red}.selectBorder input[data-v-71fc1726]:-ms-input-placeholder{color:red}.selectBorder input[data-v-71fc1726]::-ms-input-placeholder{color:red}.selectBorder input[data-v-71fc1726]::placeholder{color:red}.test[data-v-71fc1726]  .el-radio-button__inner{background:none;border:none;color:red}", ""]);

// exports
